import { extend } from 'underscore';
import { uiblockerStyle, glyphIconStyle, paginationStyle, statusStyle, helpbuttonStyle, inputFieldStyle, datePickerStyle, buttonInputStyle, learnMoreStyle } from '@bingads-webui-campaign-react/common-styles';
import { getTableStyles } from '@bingads-webui-campaign-react/grid-view-wrapper';

import { getCommonStyle, importUiBlockerStyle } from './common-style';

const getCurrencyConversionPanelStyle = () => ({
  '& .currency-conversion-control': {
    paddingTop: 10,
    '& .bold': {
      fontWeight: 'bold',
    },
    '& .inline-bold': {
      display: 'inline',
      fontWeight: 'bold',
    },
    '& input[type="radio"]': {
      margin: '0 8px',
      verticalAlign: 'middle',
      bottom: 2,
    },
    '& .form-group > .radio': {
      padding: '8px 5px 8px 0',
      width: 'max-content',
      left: -8,
      '&:focus-within': {
        outline: '1px solid #605e5c',
      },
    },
    '& .bingAccountCurrency, & .googleAccountCurrency, & .importSourceAccountCurrency': {
      paddingLeft: 20,
    },
  },
});

export const getGoogleImportStyle = (_, { palette = {} }, iconFontFamily = 'MsAds MDL2 Assets') => ({
  '@global': extend(
    {},
    uiblockerStyle({ palette }),
    glyphIconStyle({ palette }),
    helpbuttonStyle({ palette }),
    inputFieldStyle({ palette }),
    datePickerStyle({ palette }),
    importUiBlockerStyle({ palette })
  ),
  ...getCommonStyle({ palette }),
  googleImportPage: extend(
    {},
    paginationStyle({ palette }),
    statusStyle({ palette }),
    buttonInputStyle({ palette }),
    learnMoreStyle({ palette }),
    getTableStyles(_, { palette }),
    getCurrencyConversionPanelStyle(),
    {
      // override some table styles from above
      '& .import-grid tbody tr td:first-child': {
        paddingLeft: 0,
      },
      '& .import-grid tbody tr td:nth-child(3), & .import-grid thead.header tr th:nth-child(3)': {
        borderLeft: '1px solid #EDEBE9',
      },
    },
    {
      // toolbar
      '& .grid-toolbar, & .ba-search-box': {
        marginBottom: 5,
      },
      '& .grid-toolbar .grid-filter-container, & .ba-search-box .search-box__input-group': {
        display: 'inline-block',
        position: 'relative',
      },
      '& .grid-toolbar .grid-filter-container .grid-filter-input, & .ba-search-box .search-box__input-group .search-box__input': {
        width: '220px',
        padding: '6px 32px 7px 8px',
        height: 32,
        border: `1px solid ${palette.neutralSecondary}`,
      },
      '& button.filter_search_icon_small, & button.filtercloseimage, & .search-box__icon': {
        margin: 0,
        cursor: 'pointer',
        border: 'none',
        minWidth: 0,
        padding: 0,
        background: 'none',
      },
      '& button.filter_search_icon_small[disabled], & .search-box__icon[disabled]': {
        cursor: 'default',
      },
      '& .filter_search_icon_small, & .filtercloseimage, & .search-box__icon': {
        fontFamily: iconFontFamily,
        color: palette.themePrimary,
        fontSize: 16,
        position: 'absolute',
        right: 8,
        top: 4,
        height: 16,
        width: 16,
      },
      '& .filter_search_icon_small:before, .search-box__icon:before': {
        content: '"\\E721"',
      },
      '& .filtercloseimage:before': {
        content: '"\\E711"',
      },
      // grid
      '& input[type="radio"]': {
        position: 'relative',
      },
      '& .import-grid.grid-table, & .import-grid .grid-table, & .full-treeview-table, & .importCampaignsGrid .grid-table': {
        minHeight: '0',
        backgroundColor: '#e5e5e5',
        borderBottomColor: '#ddd',
        borderBottomStyle: 'solid',
        borderBottomWidth: '1px',
        margin: 0,
        border: 'none',
        padding: 0,
        height: '100%',
      },
      '& .viewport, & .full-treeview-table .tree-view-container': {
        maxHeight: '300px',
        backgroundColor: '#fff',
        // overflow is an inline style added by grid. Need to use import to override it.
        overflowX: 'hidden!important',
      },
      '& .import-grid .fixed-height .viewport, & .full-treeview-table .tree-view-container': {
        height: '300px',
      },
      '& .col-selection': {
        width: '5%',
      },
      '& .col-Currency': {
        width: '10%',
      },
      '& .import-grid .col-CustomerId': {
        width: '20%',
      },
      '& .col-Status, & .col-Type': {
        width: '15%',
      },
      '& .import-grid .col-New, & .import-grid .col-Updated, & .import-grid .col-Deleted': {
        width: '12%',
      },
      '& .import-grid .col-Skipped': {
        width: '16%',
      },
      '& .import-grid .table-container thead.header .sort-indicator': {
        marginRight: '5px',
      },
      '& .import-grid .grid-table .table-bordered': {
        '& input[type="radio"]:focus': {
          outline: `1px solid ${palette.neutralSecondary} !important`,
          outlineOffset: 1,
        },
      },
      '& .truncated': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

      // google ads campaigns and ad groups
      '& .google-campaign-grid, & .importsource-campaign-grid': {
        '& .radio>label': {
          display: 'inline-block',
        },

        '& .campaign-and-ad-group-selector': {
          paddingTop: 4,

          '& .full-treeview-table': {
            '& .table-bordered': {
              marginBottom: 0,

              '& .adgroup-level-header': {
                '& th': {
                  borderLeft: 0,
                  borderRight: 0,
                  borderTop: '2px solid #81868B',
                  borderBottom: '2px solid #81868B',
                },

                '& .column-header-select-all': {
                  width: 60,
                },

                '& .column-header-name-sortable': {
                  cursor: 'pointer',
                  width: 380,
                },

                '& .column-header-type-sortable': {
                  cursor: 'pointer',
                  width: 180,
                },
              },
            },

            '& .tree-view-container': {
              '& .ReactVirtualized__Grid': {
                paddingLeft: 5,

                '& .ReactVirtualized__Grid__innerScrollContainer': {
                  '& .glyph-caret-right, & .glyph-caret-down': {
                    fontFamily: iconFontFamily,
                    cursor: 'pointer',
                    fontSize: 16,
                    paddingRight: 10,
                    paddingLeft: 2,
                    verticalAlign: 'middle',
                  },

                  '& .glyph-caret-right:before': {
                    content: '"\\E970"',
                  },

                  '& .glyph-caret-down:before': {
                    content: '"\\E96E"',
                  },

                  '& .tree-node': {
                    '& .leaf-node': {
                      paddingLeft: 30,
                    },

                    '& .checkbox-inline span': {
                      verticalAlign: 'middle',
                    },

                    '& .checkbox-inline:focus-within': {
                      outline: 'none',
                    },

                    '& .checkbox-inline>input[type="checkbox"]:focus': {
                      outline: `1px solid ${palette.neutralSecondary}`,
                      outlineOffset: 1,
                    },

                    '& .statusEnabled_icon, & .statusPaused_icon': {
                      paddingRight: 5,
                    },

                    '& .node-name': {
                      display: 'inline-block',
                      width: 380,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },

                    '& .node-type': {
                      display: 'inline-block',
                      width: 180,
                    },
                  },
                },
              },
            },
          },
        },
      },

      // schedule imports
      '& .schedule-import-container': {
        '& .form-horizontal.schedule': {
          padding: 0,
          maxWidth: 900,

          '& .section-item.schedule.form-group': {
            marginLeft: 0,
            marginRight: 0,
          },

          '& .schedule': {
            '& h5': {
              fontSize: 14,
              fontWeight: 400,
              lineHeight: 1.5,
              margin: 0,
            },

            '& .control-label.col-xs-2': {
              textAlign: 'left',
              width: '100%',
            },

            '& .date-picker': {
              '& .date-picker-component.k-input': {
                height: '32px',
                border: `1px solid ${palette.neutralSecondary}`,
                borderRadius: 2,
                padding: '6px 12px',
              },
            },

            '& .control-label.col-xs-1': {
              width: 'auto',
            },

            '& .col-md-3.radio': {
              float: 'unset',
              padding: '8px 5px 8px 28px',
              left: '-8px',

              '&:focus-within': {
                outline: `1px solid ${palette.neutralSecondary}`,
              },

              '& input': {
                marginRight: 8,
                verticalAlign: 'bottom',
              },
            },

            '& .col-xs-2[data-bind="visible: chosenFrequency().value === \'Monthly\'"]': {
              width: 'auto',

              '& .control-label.col-xs-4, .col-xs-8': {
                width: 'auto',
              },
            },

            '& .control-label.col-xs-4, .control-label.col-xs-1': {
              paddingLeft: 0,
              paddingRight: 0,
            },

            '& #ScheduledImportValidationError': {
              listStyle: 'none',
              paddingLeft: 0,
            },

            '& ul.panel-body': {
              padding: 0,
              margin: 0,
              listStyle: 'none',
            },
          },
        },
        '& .fac-coupon-alert.fac-coupon-alert-now': {
          marginBottom: 10,
        },
      },
    }
  ),
});
